import { Alert } from '@components'
import { getContactPageUrl } from '@constants'
import { useBusinessContext } from '@context'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

interface Props {
  contactId?: number | null
  variant?: 'missingContact' | 'missingVatId' | 'privatePerson'
}

const formDescriptionKey = (variant: NonNullable<Props['variant']>): string => {
  switch (variant) {
    case 'missingContact':
      return 'document.euB2bVatFormMissingContact'
    case 'missingVatId':
      return 'document.euB2bVatFormMissingVatId'
    case 'privatePerson':
      return 'document.euPrivatePersonFormDescription'
    default: {
      const exhaustive: never = variant
      return exhaustive
    }
  }
}

export const EuB2bVatWarning: React.FC<Props> = ({ contactId, variant = 'missingVatId' }) => {
  const { t } = useTranslation()
  const { slug } = useBusinessContext()

  return (
    <Alert
      type="warning"
      marginBottom={0}
      description={
        <Copy>
          <span>{t(formDescriptionKey(variant))}</span>
          {variant === 'missingVatId' && contactId ? (
            <FixLink to={getContactPageUrl(slug, { id: contactId })}>
              {t('document.euB2bVatAddVatId')}
            </FixLink>
          ) : null}
        </Copy>
      }
    />
  )
}

export const EuB2bVatFieldWrap = styled.div<{ $warn?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}rem;

  ${({ $warn, theme }) =>
    $warn &&
    css`
      .input-wrapper {
        border-color: ${theme.colors.warning};
        background: ${theme.colors.neutralWhite};
      }
    `}
`

const Copy = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  line-height: 1.5;
`

const FixLink = styled(Link)`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
`
